/** Returns a complete same-origin document URL suitable for sharing externally. */
export function shareLink(path: string, origin: string): string {
  return new URL(path, origin).toString();
}
